/**
 * Handle Video instances Play/Pause
 */
// Create array for player IDs
let players = [];

// Determine the available player IDs
for (let i = 0; i < Object.keys(videojs.players).length; i++) {
    // Assign the player name to setPlayer
    var setPlayer = Object.keys(videojs.players)[i];

    // Define the ready event for the player
    videojs.getPlayer(setPlayer).ready(function () {
        // Assign this player to a variable
        let myPlayer = this;

        // Assign and event listener for play event
        myPlayer.on("play", onPlay);

        // Push the player to the players array
        players.push(myPlayer);
    });
}

// Handle all players' play event 
function onPlay(e) {
    // Determine which player the event is coming from
    var id = e.target.id;

    // Loop through the array of players
    for (let x = 0; x < players.length; x++) {
        // Get the player(s) that did not trigger the play event
        if (players[x].id() != id) {
        // Pause the other player(s)
        videojs(players[x].id()).pause();
        }
    }
}

if (
    $('#hero-video').length && 
    $('#hero-video source').attr('data-src-mobile') != undefined &&
    $('#hero-video source').attr('data-src-desktop') != undefined
) {
    const desktopSrc = $('#hero-video source').attr('data-src-desktop');
    const mobileSrc = $('#hero-video source').attr('data-src-mobile');

    function updateHeroVslSrc() {
        if ($(window).width() < 768) {
            if ( videojs('hero-video').src() == desktopSrc) {
                videojs('hero-video').src({ src: mobileSrc});
            }
        } else {
            if ( videojs('hero-video').src() == mobileSrc ) {
                videojs('hero-video').src({ src: desktopSrc});
            }
        }
    }

    if (desktopSrc != mobileSrc) {
        updateHeroVslSrc();

        $(window).on('resize', function () {
            updateHeroVslSrc();
        });
    }
}

if ($('#hero-video').length  && $(window).width() < 1024) {
    let touchmoved;

    if ($('#hero-video video').get(0).paused) {
        videojs('hero-video').play();
    }

    $('#hero-video').on('touchend', function() {
        if(touchmoved != true) {
            if ($('#hero-video video').get(0).paused) {
                videojs('hero-video').play();
            } else {
                videojs('hero-video').pause();
            }
        } 
    }).on('touchmove', function(){
        touchmoved = true;
    }).on('touchstart', function(){
        touchmoved = false;
    });
}